import classNames from "classnames";
import { ReactComponent as Email } from "../../assets/email.svg";
import { ReactComponent as Github } from "../../assets/github.svg";
import { ReactComponent as Linkedin } from "../../assets/linkedin.svg";

function Footer({ className }) {
  return (
    <div
      style={{ border: "none", borderTop: "1px solid black" }}
      className={classNames(
        "w-full h-max footer flex justify-center items-center",
        className
      )}
    >
      <div className="h-full w-[80%] flex flex-col items-center">
        <div className="footer-initials select-none mt-4">RS.</div>
        <div className="mt-2 mb-4 text-sm text-center">
          Learning new things. One day at a time.
        </div>
        <div className="w-[90%] mt-7 flex flex-row items-center justify-evenly">
          <a
            href="https://www.linkedin.com/in/rohan-sharma-323593202/"
            target="_blank"
            rel="noreferrer"
            title="LinkedIn"
            className="w-max h-max"
          >
            <Linkedin />
          </a>
          <a
            href="https://github.com/rohan843"
            target="_blank"
            rel="noreferrer"
            title="GitHub"
            className="w-max h-max"
          >
            <Github />
          </a>
          <a
            href="mailto:rohan.sharma2934@gmail.com"
            title="Email"
            className="w-max h-max"
          >
            <Email />
          </a>
        </div>
        <div className="mb-3 mt-7 text-center w-[90%]">
          Designed and programmed by yours truly.
        </div>
        <div className="text-[0.6rem] my-1">
          <a
            href="https://gist.githubusercontent.com/rohan843/85be345cb966cbad10405136643d1597/raw/3da93a91bef1db504808b1d3e359e08945f254ff/disclaimer.txt"
            className="underline px-1"
            target="_blank"
            rel="noreferrer"
          >
            disclaimer
          </a>
          <a
            href="https://gist.githubusercontent.com/rohan843/b0125c40a2a82a9485f1fddb894a4d50/raw/35eaff2b6fe02cd20d5e488112c7d8fc8d96c31f/acknowledgements.txt"
            className="underline px-1"
            target="_blank"
            rel="noreferrer"
          >
            acknowledgements
          </a>
        </div>
        <div className="text-xs my-1">
          &copy; {new Date().getUTCFullYear()} Rohan Sharma
        </div>
      </div>
    </div>
  );
}

export default Footer;
